<template>
  <div>
    <rabbey-toolbox>
      <div class="mr-5">
        <yearcomponent @change="handler_year" class="box-item"></yearcomponent>
      </div>
    </rabbey-toolbox>

    <!-- INICIO DE LOS TABS -->
    <!-- <el-tabs v-model="activeTab" @tab-click="handleTabClick"> -->
    <el-tabs v-model="OnlyActiveTab" @tab-click="handleTabClick">
      <el-tab-pane label="KPI de Tareas Gantt" name="KpiGanttCharges">
        <rabbey-table3
          ref="KpiGanttCharges"
          v-loading="loading"
          :columns="columnsKpi"
          :show-summary="false"
          :data.sync="items"
        />
      </el-tab-pane>
    </el-tabs>
    <!-- </el-tabs> -->
    <!-- FIN DE LOS TABS -->

    <!-- table detalle de tareas -->
    <rabbey-base-drawer
      title="Reporte de Tareas"
      :drawer.sync="cobros"
      size="80%"
    >
      <el-row>
        <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
          <el-row style="padding: 20px">
            <table style="font-size: 22px" id="table-card">
              <tr>
                <td>Dirección:</td>
                <td>
                  <strong> {{ executive }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>

        <el-col :span="3" :xs="3" :sm="24" :md="24" :lg="3">
          <el-row style="padding: 20px">
            <table style="font-size: 22px" id="table-card">
              <tr>
                <td>Año:</td>
                <td>
                  <strong> {{ year }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
        <el-col :span="3" :xs="3" :sm="24" :md="24" :lg="3">
          <el-row style="padding: 20px">
            <table style="font-size: 22px" id="table-card">
              <tr>
                <td>Mes:</td>
                <td>
                  <strong> {{ month }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" :xs="6" :sm="24" :md="24" :lg="6">
          <el-row style="padding: 10px">
            <table style="font-size: 22px" id="table-card">
              <tr>
                <td>Tareas Registradas:</td>
                <td>
                  <strong> {{ totalTasks }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>

        <el-col :span="6" :xs="6" :sm="24" :md="24" :lg="6">
          <el-row style="padding: 10px">
            <table style="font-size: 22px" id="table-card">
              <tr>
                <td>Cerradas a tiempo:</td>
                <td>
                  <strong> {{ Number(this.totalCompleted).toFixed(0) }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
        <el-col :span="6" :xs="6" :sm="24" :md="24" :lg="6">
          <el-row style="padding: 10px">
            <table style="font-size: 22px" id="table-card">
              <tr>
                <td>Cerradas tarde:</td>
                <td>
                  <strong>
                    {{ Number(this.totalCompletedLate).toFixed(0) }}</strong
                  >
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
        <el-col :span="6" :xs="6" :sm="24" :md="24" :lg="6">
          <el-row style="padding: 10px">
            <table style="font-size: 22px" id="table-card">
              <tr>
                <td>Efectividad:</td>
                <td>
                  <el-tag
                    style="font-size: 25px"
                    type="success"
                    v-if="Effectividad > 99"
                    >{{ `${Effectividad}` + `.00` }} %
                  </el-tag>

                  <el-tag
                    style="font-size: 25px"
                    type="danger"
                    v-if="Effectividad < 80"
                    >{{ `${Effectividad}` + `.00` }} %</el-tag
                  >

                  <el-tag
                    style="font-size: 25px"
                    type="warning"
                    v-if="Effectividad >= 80 && Effectividad <= 99"
                    >{{ `${Effectividad}` + `.00` }} %</el-tag
                  >
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
      </el-row>
      <rabbey-toolbox filterables @filter-search="detailSearch = $event" />

      <el-row>
        <el-col>
          <rabbey-table3
            ref="table"
            :search="detailSearch"
            :loading.sync="loadingDetails"
            :columns="columnsDetails"
            :data="registers"
          />
        </el-col>
      </el-row>
    </rabbey-base-drawer>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { GetMonthInLetterBeginingOnZero, formatMonto } from "../../../../utils";
import yearcomponent from "@/components/Global_System/YearsComponent";
import HyperLink from "@/components/functionals/HyperLink.vue";
import HyperLinkTab from "@/components/functionals/HyperLinkTab.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import ColorInternarStatus from "@/components/functionals/ColorInternarStatus";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";

export default {
  name: "CollectionList",
  components: { yearcomponent },
  computed: {
    ...mapState("my_request", [
      "swichMyRequest",
      "tabActiveName",
      "search",
      "loading",
      "sectionSelected"
    ]),
    activeName: {
      get() {
        return this.tabActiveName;
      },
      set(val) {
        this.SET_TAB_ACTIVE_NAME(val);
      }
    },
    isValid: function () {
      return this.form.comment.trim().length > 5 && this.form.newdate !== null;
    },
    Cant: function () {
      return this.registers.length;
    },
    TotalG: function () {
      // if (this.registers.length <= 0) {
      //   return 0;
      // }

      return this.registers.length;
    }
  },
  data() {
    return {
      totalCompleted: 0,
      totalCompletedLate: 0,
      totalTasks: 0,
      Effectividad: 0,
      rowValKpi: 0,
      loading: false,
      invoicesPending: "",
      activeTab: "",
      detailSearch: "",
      principalTable: false,
      loadingDetails: false,
      cobros: false,
      formpayment: false,
      year: new Date().getFullYear(),
      value: "",
      TypeAgent: "accountingmanager",
      type: "Cantidad",
      executive: "",
      contacts: [],
      loadingContacts: false,
      month: "",
      AccountNumber: "",
      Amount: 0,
      InvoiceNum: "",
      ContactEmail: "",
      form: {
        currentdate: "",
        newdate: "",
        comment: "",
        contactCode: ""
      },
      columns: [
        {
          prop: "ExecutiveName",
          label: "Ejecutivo",
          minWidth: 220,
          fixed: true
        }
      ],
      columnsCharged: [
        {
          prop: "Direccion",
          label: "Dirección",
          minWidth: 220,
          fixed: true
        },
        {
          prop: "January",
          label: this.$t(`months.January`),
          name: this.$t(`months.January`),
          minWidth: 150,

          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 1
          },
          formatter: HyperLinkTab
        },
        {
          prop: "February",
          label: "Febrero",
          minWidth: 150,

          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 2
          },
          formatter: HyperLinkTab
        },
        {
          prop: "March",
          label: "Marzo",
          minWidth: 150,

          name: "March",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 3
          },
          formatter: HyperLinkTab
        },
        {
          prop: "April",
          label: "Abril",
          minWidth: 150,

          name: "April",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 4
          },
          formatter: HyperLinkTab
        },
        {
          prop: "May",
          label: "Mayo",
          minWidth: 150,

          name: "May",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 5
          },
          formatter: HyperLinkTab
        },
        {
          prop: "June",
          label: "Junio",
          minWidth: 150,

          name: "Junio",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 6
          },
          formatter: HyperLinkTab
        },
        {
          prop: "July",
          label: "Julio",
          minWidth: 150,

          name: "Julio",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 7
          },
          formatter: HyperLinkTab
        },
        {
          prop: "August",
          label: "Agosto",
          minWidth: 150,

          name: "Agosto",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 8
          },
          formatter: HyperLinkTab
        },
        {
          prop: "September",
          label: "September",
          minWidth: 150,

          name: "September",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 9
          },
          formatter: HyperLinkTab
        },
        {
          prop: "October",
          label: "October",
          minWidth: 150,

          name: "October",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 10
          },
          formatter: HyperLinkTab
        },
        {
          prop: "November",
          label: "November",
          minWidth: 150,

          name: "November",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 11
          },
          formatter: HyperLinkTab
        },
        {
          prop: "December",
          label: "December",
          minWidth: 150,

          name: "December",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 12
          },
          formatter: HyperLinkTab
        }
      ],
      columnsKpi: [
        {
          prop: "Direccion",
          label: "Dirección",
          minWidth: 220,
          fixed: true
        },
        {
          prop: "January",
          label: this.$t(`months.January`),
          name: this.$t(`months.January`),
          minWidth: 150,

          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 1
          },
          formatter: HyperLink
        },
        {
          prop: "February",
          label: "Febrero",
          minWidth: 150,

          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 2
          },
          formatter: HyperLink
        },
        {
          prop: "March",
          label: "Marzo",
          minWidth: 150,

          name: "March",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 3
          },
          formatter: HyperLink
        },
        {
          prop: "April",
          label: "Abril",
          minWidth: 150,

          name: "April",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 4
          },
          formatter: HyperLink
        },
        {
          prop: "May",
          label: "Mayo",
          minWidth: 150,

          name: "May",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 5
          },
          formatter: HyperLink
        },
        {
          prop: "June",
          label: "Junio",
          minWidth: 150,

          name: "Junio",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 6
          },
          formatter: HyperLink
        },
        {
          prop: "July",
          label: "Julio",
          minWidth: 150,

          name: "Julio",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 7
          },
          formatter: HyperLink
        },
        {
          prop: "August",
          label: "August",
          minWidth: 150,

          name: "August",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 8
          },
          formatter: HyperLink
        },
        {
          prop: "September",
          label: "September",
          minWidth: 150,

          name: "September",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 9
          },
          formatter: HyperLink
        },
        {
          prop: "October",
          label: "October",
          minWidth: 150,

          name: "October",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 10
          },
          formatter: HyperLink
        },
        {
          prop: "November",
          label: "November",
          minWidth: 150,

          name: "November",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 11
          },
          formatter: HyperLink
        },
        {
          prop: "December",
          label: "December",
          minWidth: 150,

          name: "December",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 12
          },
          formatter: HyperLink
        }
      ],
      columnsDetails: [
        {
          prop: "taskID",
          label: "No. Tarea",
          width: 150,
          sortable: true
        },
        {
          prop: "TaskName",
          label: "Tarea",
          minWidth: 150,
          sortable: true
        },
        {
          prop: "Description",
          label: "Descripción",
          minWidth: 200,
          sortable: true,
          formatter: (row) =>
            `${row.Description ? row.Description.substring(0, 100) : ""}...`
        },
        {
          prop: "Fecha",
          label: "Fecha Inicio",
          minWidth: 150,
          sortable: true,
          formatter: DatetimeFormatter
        },
        {
          prop: "Fecha_limite",
          label: "Fecha Compromiso",
          minWidth: 170,
          sortable: true,
          formatter: DatetimeFormatter
        },
        {
          prop: "Fecha_Cierre",
          label: "Fecha Cierre",
          minWidth: 150,
          sortable: true,
          formatter: DatetimeFormatter
        },
        {
          prop: "percentageStatus",
          label: "Porcentaje",
          minWidth: 130,
          sortable: true
        },
        {
          prop: "Estado",
          label: "Status",
          minWidth: 150,
          sortable: true,
          formatter: ColorInternarStatus
        },
        {
          prop: "Responsable",
          label: "Responsable",
          minWidth: 250,
          sortable: true,
          formatter: ImagePerson,
          attrs: {
            imgKey: "imageUrl"
          }
        }
      ],

      items: [],
      itemsInvoices: [],
      itemsCharged: [],
      itemsPending: [],
      itemsKpi: [],
      itemsDetails: [],
      registers: [],
      itemEntryDetails: [],
      comments: [],
      Dcoments: false,
      entryDocDrawer: false,
      commentloading: false,
      request: null, // Seguimiento de solicitud, para su cancelacion.
      OnlyActiveTab: "KpiGanttCharges"
    };
  },
  mounted() {
    this.principalTable = true;
    //this.getData();
    //this.getDataCharged();
    this.getKPI();
  },
  created() {
    this.principalTable = true;
  },
  methods: {
    ...mapMutations("my_request", [
      "TOGGLE_GET_MY_REQUEST",
      "SET_TAB_ACTIVE_NAME",
      "SET_TAB_ACTIVE_SECTION_NAME",
      "SET_BY_EMPLOYEE_ID",
      "SET_ALL_MY_REQUESTS",
      "SET_SEARCH",
      "TOGGLE_LOADING",
      "SET_BY_DIRECCTION_ID"
    ]),
    formatMonto,
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totales";
          return;
        }

        let col = column.property;
        if (this.type === "Monto") {
          col = `${column.property}Amount`;
        }

        const values = data.map((item) => Number(item[col]));
        if (!values.every((value) => isNaN(value))) {
          let val = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          if (this.type === "Monto") {
            val = this.formatMonto(val);
          }

          sums[index] = val;
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    OpenSelection(mes, vendor, name, rowVal) {
      this.rowValKpi = rowVal;
      let codeType = typeof vendor;
      mes = mes - 1;
      this.month = GetMonthInLetterBeginingOnZero(mes);
      mes = mes + 1;
      this.cobros = true;
      //console.log(name);
      this.executive = vendor.Direccion;
      if (codeType == "string") {
        this.getDetailsinfo(vendor, mes, this.year);
      } else {
        this.getDetailsinfo(vendor.Id, mes, this.year);
      }
    },
    OpenEntryDetails(vendor) {
      this.entryDocDrawer = true;
      this.EntryDetails(vendor.EntryNo);
    },
    getType() {
      return this.type;
    },
    onSubmit() {
      var data = {
        OldDate: this.form.currentdate,
        newDate: this.form.newdate,
        Concept: this.form.comment,
        AccountNumber: this.AccountNumber,
        Amount: this.Amount,
        InvoiceNum: this.invoiceNum,
        ContactEmail: "",
        ContactCode: this.form.contactCode,
        CompanySelected: this.currentCompany
      };

      this.$http
        .post("/api/AccountsReceivable/ChangeDataFromDueDateToFutureDate", data)
        .then(({ data }) => {
          if (data) {
            this.formpayment = false;
            if (data.AddInteraction) {
              let msg =
                "Se ha creado una interacion con este compromiso de pago";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  title: "Creacion de Interacion",
                  position: "top-left"
                });
              }, 1500);
            }
            if (data.NotifyCustomer) {
              let msg = "El contacto ha sido notificado via correo";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  offset: 10,
                  title: "Notificacion a cliente",
                  position: "top-left"
                });
              }, 1500);
            }
            if (data.CashFlowModify) {
              let msg =
                "Se ha creado un movimiento en cashflow con este compromiso";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  offset: 20,
                  title: "Registro en cashflow",
                  position: "top-left"
                });
              }, 1500);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.handleClose();
        });
    },
    handler_year(_year) {
      this.principalTable = true;
      this.year = _year;
      //this.getData();
      //this.getDataCharged();
      this.getKPI();
    },
    handleClose() {
      this.form.currentdate = "";
      this.form.newdate = "";
      this.form.comment = "";
      this.form.contactCode = "";
      this.AccountNumber = "";
      this.Amount = "";
      this.InvoiceNum = "";
      this.ContactEmail = "";
    },

    getContactsByCustomerCode(customerCode = String) {
      this.loadingContacts = true;
      this.$http
        .get("/api/contacts/GetContactByCustomerCode", {
          params: {
            customerCode: customerCode,
            companyCode: this.currentCompany
          }
        })
        .then(({ data }) => {
          this.contacts = data;
        })
        .catch((err) => {
          this.$message.error(
            `no se pudieron tener contacto sobre este cliente ${err}`
          );
        })
        .finally(() => {
          this.loadingContacts = false;
        });
    },
    handlerChanges() {
      this.principalTable = true;
    },

    async getKPI() {
      this.loading = true;
      const params = {
        typeAgent: this.TypeAgent,
        year: this.year,
        companyId: this.currentCompany,
        option: "gantt"
      };

      this.$http
        .get("/api/CMI/Task/KpiTaskByDirecction", {
          timeout: 9000 * 100,
          params: params
        })
        .then(({ data }) => {
          this.items = data;
          this.itemsKpi = data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleTabClick() {
      let self = this;
      this.$nextTick(() => {
        switch (self.OnlyActiveTab) {
          case "KpiGanttCharges":
            if (this.itemsKpiGantt.length > 0) {
              this.itemsGantt = this.itemsKpiGantt;
            } else {
              this.getKPI();
            }
            this.ShowHideFilters(self.OnlyActiveTab);
            break;
          default:
            break;
        }
      });
    },
    getDetailsinfo(code, month = Number, year = Number) {
      this.totalCompleted = 0;
      this.totalCompletedLate = 0;
      this.loadingDetails = true;
      let uri;
      let option;
      switch (this.OnlyActiveTab) {
        case "invoices":
          uri = `/api/CMI/Task/TaskByDirecctionDetails`;
          break;
        case "charges":
          uri = `/api/CMI/Task/TaskCompletedByDirecctionDetails`;
          break;
        case "KpiGanttCharges":
          uri = `/api/CMI/Task/KpiTaskByDirecctionDetails`;
          option = "gantt";
          break;
        default:
          break;
      }
      this.$http
        .get(uri, {
          params: {
            DirecctionId: code,
            month: month,
            year: year,
            CompanyId: this.currentCompany,
            typeAgent: this.TypeAgent,
            option: option
          }
        })
        .then(({ data }) => {
          console.log("llegue");
          this.registers = [];
          this.registers = data.Tareas;
          console.log(data.Tareas);
          this.totalCompleted = data.CerradasAtiempo;
          this.totalCompletedLate = data.CerradasTarde;
          this.totalTasks = data.TotalTarea;
          this.Effectividad = data.Effectividad;
          // this.registers.forEach((c) => {
          //   if (c.Estado == "Cerrada a tiempo") {
          //     this.totalCompleted = this.totalCompleted + 1;
          //   }
          //   if (c.Estado == "Cerrada tarde") {
          //     this.totalCompletedLate = this.totalCompletedLate + 1;
          //   }
          // });
          this.loadingDetails = false;
        })
        .catch((error) => {
          this.$message.error("Error al consultar los Registros");
          console.error(error);
        })
        .finally(() => {
          this.loadingDetails = false;
        });
    },

    ShowHideFilters(val) {
      const getValType = typeof val;
      if (getValType === "string") {
        if (val == "invoicesPending") {
          this.invoicesPending = true;
        } else {
          this.invoicesPending = false;
        }
      } else {
        this.invoicesPending = false;
      }
    }
  }
};
</script>

<style>
#table-card td {
  padding-left: 10px;
}
.col-p {
  padding: 0 10px;
  box-sizing: border-box;
}
</style>
